import $ from "jquery";

const footerObject = {
  variables: {
    quickLinkBtn: $(".quick__Link__btn"),
    quickLinkAccordion: $(".quick__link__Accordion"),
    flag: true,
    url: window.location.href,
  },

  methods: {
    accordionCollapse: function () {
      footerObject.variables.quickLinkBtn.on("click", function (e) {
        $(".quick__Link__btn[data-toggle='true']").addClass('collapsed').attr('data-toggle', false).attr('aria-expanded', 'false');
        if (footerObject.variables.quickLinkAccordion.hasClass("show")) {
          footerObject.variables.quickLinkAccordion.removeClass("show");
        }
        $(this).attr('data-toggle', true);

        var obj = footerObject.methods.dataLayerObj("QuickLinks", e);
        createDataLayer("Expand", obj);
      });
    },
    sitemapView: function () {
      if ($('.footer__row--third').hasClass('site-map')) {
        var title = $('.site-map').find('.link__list__mob .list__link__title');

        let emptyTitle = [];

        title.each(function (index, element) {
          if ($(element).text().trim() == '') {
            emptyTitle.push(element);
          }
        });

        for (let i = 0; i <= emptyTitle.length; i++) {
          var $ele = emptyTitle[i];
          $($ele).parents('.accordion').hide();
          const list = $($ele).parents('.link__list__mob').find('.list__link__listing');
          $($ele).parents('.link__list__mob').append(list);
        }

      }
    },
    sitemapAccordion: function () {
      if ($('.footer__row--third').hasClass('site-map')) {
        if ($(window).width() < 768) {
          $('.site-map').find('.accordion-button').on('click', function () {
            const $accordion = $(this).closest('.accordion');
            if (!$(this).hasClass('collapsed')) {
              $accordion.css({
                'border': '1px solid #0c73b4',
                'background-color': '#f1fbfe'
              });
            } else {
              $accordion.css({
                'border': '1px solid #d0d0d0',
                'background-color': 'transparent'
              });
            }

          });

          $('.site-map').find('.list__link__list a').before('<span><svg aria-hidden="true" class="check-circle-icon text-blue-400"><use xlink:href="/etc.clientlibs/chli/clientlibs/clientlib-site/resources/images/sprite/sprite.svg#check-circle" /></svg></span>');
          $('.site-map').find('.list__link__list').addClass('d-flex gap-2');
          $('.site-map').find('.list__link__listing').css('column-count', 'unset');

          $('.site-map').find('.accordion').each(function(){
            if($(this).is(':hidden')){
              $(this).parents('.linklist').css('border-bottom','1px solid #d0d0d0');
            }else{
              $(this).parents('.linklist').css('border-bottom','0');
            }
          });
        }
      }

    },

    socialMedia: function () {
      $(".footer__social__links--link").on("click", function (e) {
        let iconName = e.currentTarget.getAttribute('icon');
        var obj = footerObject.methods.dataLayerObj("SocialIcons", iconName);
        createDataLayer("SocialMediaShare", obj);
      });
    },

    downloadClick: function () {
      $(".footer_download_app_inner_list").on('click', function (e) {
        let text = e.currentTarget.getElementsByTagName("img")[0].getAttribute("alt");
        var obj = footerObject.methods.dataLayerObj("DownloadSection", text);
        createDataLayer("buttonClick", obj);
      });
    },

    logoClick: function () {
      $(".footer__logo").on("click", function () {
        var obj = footerObject.methods.dataLayerObj("Logo", "LogoClick");
        createDataLayer("LogoClick", obj);
      });
    },
    warningTextAlignment: function () {
      const textAlignment = $(".warning__section__text").attr("data-alignment");
      $(".warning__section__text").addClass("text-" + textAlignment);
    },

    buttonClick: function () {
      $(".chlifooter .list__link__list").on("click", function (e) {
        var obj = footerObject.methods.dataLayerObj("PopularLinks", e);
        createDataLayer("FooterClick", obj);
      });
    },

    quickLinkClick: function () {
      $(".quick__links__wrapper li").on("click", function (e) {
        var obj = footerObject.methods.dataLayerObj("QuickLinks", e);
        createDataLayer("FooterClick", obj);
      });
    },

    popularArticle: function () {
      $(".popular__article__text").on('click', function (e) {
        var obj = footerObject.methods.dataLayerObj("PopularArticles", e, e.currentTarget.innerText.replace(/\n/g, '').trim());
        createDataLayer("FooterClick", obj);
      });
    },

    partnerClick: function () {
      $(".footer__row--fifth .swiper-slide").on('click', function(e){
          let title = e.currentTarget.getElementsByTagName("img")[0].getAttribute("alt");
          var obj = footerObject.methods.dataLayerObj("Partners", title);
          createDataLayer("LogoClick", obj);
      });
    },

    quickLinkClickAccordion: function () {
      $(".link__list__mob").on("click", function () {
        var obj = footerObject.methods.dataLayerObj("QuickLinks");
        createDataLayer("Expand", obj);
      });
    },

    popularArticleAccordion: function () {
      $(".popular_articl_title .accordion-button").on("click", function (e) {
        if (!e.currentTarget.classList.contains('collapsed')) {
          var obj = footerObject.methods.dataLayerObj("PopularArticles","Popular Articles");
          createDataLayer("Expand", obj);
        }
      });
    },

    footerEmail: function () {
      $(".footer__contact__email").on('click', function (e) {
        var obj = footerObject.methods.dataLayerObj("Mail", e.currentTarget.innerText.trim());
        createDataLayer("buttonClick", obj);
      });
    },

    footerPhone: function () {
      $(".footer__contact__phone").on('click', function (e) {
        var obj = footerObject.methods.dataLayerObj("Phone", e.currentTarget.innerText.trim());
        createDataLayer("buttonClick", obj);
      });
    },

    disclaimerAccordion: function () {
      $(".disclaimer__title .accordion-button").on("click", function () {
        var obj = footerObject.methods.dataLayerObj("Disclaimer","Disclaimer");
        createDataLayer("Expand", obj);
      });
    },
    disclaimerLink: function(){
      $(".rte-text a").on('click', function(e){
        if(!e.currentTarget.classList.contains('collapsed')){
            var obj = footerObject.methods.dataLayerObj("Disclaimer", e);
            createDataLayer("buttonClick", obj);
        }
      });
    },

    // span[role=button] accordion toggles: activate with Enter/Space like a native button.
    accordionKeyboard: function () {
      $(".popular_articl_title .accordion-button, .disclaimer__title .accordion-button").on("keydown", function (e) {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          this.click();
        }
      });
    },

    addBgColor: function () {
      const bgColor = $('.privacyPolicyText__section').attr('data-bg-color');
      $('.privacyPolicyText__section').css('background-color', bgColor);
    },

    init: function () {
      this.accordionCollapse();
      this.socialMedia();
      this.logoClick();
      this.warningTextAlignment();
      this.buttonClick();
      this.quickLinkClick();
      this.quickLinkClickAccordion();
      this.disclaimerAccordion();
      this.popularArticleAccordion();
      this.popularArticle();
      this.downloadClick();
      this.addBgColor();
      this.accordionKeyboard();
      this.partnerClick();
      this.footerEmail();
      this.footerPhone();
      this.sitemapView();
      this.sitemapAccordion();
    },

    dataLayerObj: function (section, e, articleName) {
      var obj = {
        'articleName': articleName? articleName : "",
        'blogCategory': "",
        'blogPageCategory': "",
        'buttonText': e ? typeof (e) == 'string' ? e : e.currentTarget.innerText.replace(/\n/g, '').trim() : "",
        'pageSection': "Footer_" + section,
        'pageType': document.querySelector("meta[name='template']").content == 'chli-base-page-template' ? footerObject.variables.url.includes("blog") ? "Blogs" : footerObject.variables.url.substring(footerObject.variables.url.indexOf(".com/"), footerObject.variables.url.lastIndexOf('/') === ".com") && !footerObject.variables.url.substring(footerObject.variables.url.indexOf(".com/"), footerObject.variables.url.length - 1).includes('/') ? "Home" : "Other Pages" : "Blog Details Page",
        'planOption': "",
        'productCategory': "",
        'productName': "",
        'question': "",
        'searchTerm': "",
        'videoTitle': "",
        'bannerName': "",
        'bannerType': ""
      };
      return obj;
    },
    dataLayerObjSocial: function (e) {
      var obj = {
        'articleName': "",
        'blogCategory': "",
        'blogPageCategory': "",
        'buttonText': e ? e.replace(/\n/g, '').trim() : "",
        'pageSection': "Footer",
        'pageType': document.querySelector("meta[name='template']").content == 'chli-base-page-template' ? footerObject.variables.url.includes("blog") ? "Blogs" : footerObject.variables.url.substring(footerObject.variables.url.indexOf(".com/"), footerObject.variables.url.lastIndexOf('/') === ".com") && !footerObject.variables.url.substring(footerObject.variables.url.indexOf(".com/"), footerObject.variables.url.length - 1).includes('/') ? "Home" : "Other Pages" : "Blog Details Page",
        'planOption': "",
        'productCategory': "",
        'productName': "",
        'question': "",
        'searchTerm': "",
        'videoTitle': "",
        'bannerName': "",
        'bannerType': ""
      };
      return obj;
    }
  },
};

$(() => {
  if ($(".footer__section").length > 0) {
    footerObject.methods.init();
  }

});
